import { AxiosError, AxiosRequestConfig } from 'axios';
import { IcityDetails } from '../types/cities.types';
import { apiGet } from './api';
const { REACT_APP_ORGANIZATION } = process.env;

/**
 * @param countryId The id of the country in the organization MS
 * @returns The list of defined cities for that country
 */
export const getCitiesByCountry = async (countryId: string | number) => {
  return apiGet<AxiosRequestConfig, IcityDetails[]>(`${REACT_APP_ORGANIZATION}/city/by-country/${countryId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
